import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
}

export const ErrorState = ({ error, onRetry, className = 'min-h-[calc(100vh-150px)]' }: ErrorStateProps) => {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <div className={`flex items-center justify-center px-6 ${className}`}>
      <div className="max-w-md text-center">
        <p className="mb-2 font-medium text-title">{t('shipmentStatusMapping.messages.errorLoading')}</p>
        <p className="mb-4 text-sm text-subtext">{error.message}</p>
        <Button variant="outline" onClick={onRetry}>
          {t('shipmentStatusMapping.messages.retry')}
        </Button>
      </div>
    </div>
  );
};
